import {Routes} from '@angular/router';
import {DevicesComponent} from '@pages/devices/devices.component';

export const DEVICES_ROUTES: Routes = [
  {
    path: '',
    component: DevicesComponent,
    data: {
      title: 'Dispositivi',
      titleKey: 'menu.devices',
      urls: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Devices' },
      ],
    }
  }
];
